"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TODAY = void 0;
exports.TODAY = {
    alias: 'HOJE',
    description: 'Retorna a data atual',
    arg_names: [],
    args_description: [],
};
